export default __webpack_public_path__ + "static/media/cpf.40a739ca.png";